import React, { useState } from "react";
import CloseIcon from "../../assests/images/closeIcon.svg";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import SideMenuContent from "../../constants/contentFile.json";
import ConfirmBox from "../confirmationModal/ConfirmBox";
import { TopBar } from "../topBar/TopBar";
import "./sideMenu.css";
import RouteConstant from "../../constants/routesContent.json";
import { userLogout } from "../../apis/Api";
import LogoutAlert from "../alertComponent/AlertBox";
import { useCookies } from 'react-cookie';

export const SideMenu = ({ children }) => {
  const Content = SideMenuContent.sideMenu;
  const errorMsgs = SideMenuContent.errorMessages;
  const textContents = SideMenuContent.logout;
  const [sidebar, setSidebar] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [showLogoutAlert, setShowLogoutAlert] = useState(false);
  const [logoutAlertMessage, setLogoutAlertMessage] = useState("");
  const navigate = useNavigate();
  const [cookies, setCookie, removeCookie] = useCookies(['user']);

  const showSidebar = () => {
    setSidebar(!sidebar);
  };

  const logout = async () => {
    try {
      if (!cookies.xAccessToken) {
        removeCookie('xAccessToken', { path: '/' });
        removeCookie('supplierId', { path: '/' });
        removeCookie('userId', { path: '/' });
        removeCookie('intentToken', { path: '/' });
        removeCookie('isZonalHead', { path: '/' });
        removeCookie('Share-Token', { path: '/' });
        removeCookie("Intent-Id", { path: "/" });
        navigate(RouteConstant.LOGIN);
      } else {
        const logoutData = await userLogout();

        if (logoutData?.data?.statusCode === 200) {
          removeCookie('xAccessToken', { path: '/' });
          removeCookie('supplierId', { path: '/' });
          removeCookie('userId', { path: '/' });
          removeCookie('intentToken', { path: '/' });
          removeCookie('isZonalHead', { path: '/' });
          removeCookie('Share-Token', { path: '/' });
           removeCookie("Intent-Id", { path: "/" });
          navigate(RouteConstant.LOGIN);
        } else {
          setShowLogoutAlert(true);
          setLogoutAlertMessage(errorMsgs.somethingWrong);
        }
      }
    } catch (error) {
      setShowConfirm(false);
      if (error?.response?.data?.statusCode === 401) {
        setShowLogoutAlert(true);
        setLogoutAlertMessage(errorMsgs.sessionExpired);
      } else {
        setShowLogoutAlert(true);
        setLogoutAlertMessage(errorMsgs.somethingWrong);
      }
    }
  };
  
  const logOutHandler = (data) => {
    if (data === "loggingOut") {
      setShowConfirm(true);
    }
  };
  return (
    <>
      <TopBar onClick={showSidebar} />
      <div className="d-flex">
        <nav className="side-menu">
          <ul className="nav-list">
            {Content.map((item, index) => {
              return (
                <li key={index} className={item.cName}>
                  <Link
                    to={item.path}
                    onClick={() => {
                      logOutHandler(item.function);
                    }}
                  >
                    <div className={item.icon}></div>
                    <span>{item.title}</span>
                  </Link>
                </li>
              );
            })}
          </ul>
        </nav>

        <nav className={sidebar ? "nav-menu active" : "nav-menu"}>
          <ul className="nav-list">
            <li className="navbar-toggle" onClick={showSidebar}>
              <img src={CloseIcon} alt="Close" />
            </li>
            {Content.map((item, index) => {
              return (
                <li key={index} className={item.cName}>
                  <Link
                    to={item.path}
                    onClick={() => {
                      logOutHandler(item.function);
                    }}
                  >
                    <div className={item.icon}></div>
                    <span>{item.title}</span>
                  </Link>
                </li>
              );
            })}
          </ul>
        </nav>
        <main>{children}</main>
      </div>
      <ConfirmBox
        show={showConfirm}
        setShow={setShowConfirm}
        title={"Logout"}
        confirmMessage={"Do you want to logout ?"}
        confirmFunc={() => {
          logout();
        }}
      />
      <LogoutAlert
          show={showLogoutAlert}
          setShow={setShowLogoutAlert}
          title={textContents.alert}
          alertMessage={logoutAlertMessage}
        />
    </>
  );
};
